<template>
	<div class="position-relative z-index-1028">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-top d-block nav-bottom">
        <div class="custom-container-fluid px-0">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="bg-green z-index-1038">
                <div class="container px-4 w-100 py-1 height-nav">
                  <div class="row no-gutters py-2 m-0 w-100">
                    <div class="col-1">
                      <template>
                        <router-link :to="link_back">
                          <img src="../../assets/img/icon/arrow-white.png" class="mt-1" width="15">
                        </router-link>
                      </template>
                    </div>
                    <div class="col-11">
                      <div class="">
                        <transition name="fade">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 text-white" v-if="step==1">{{$t('hotel.form-order')}}</p>
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1 text-white" v-if="step==2">{{$t('hotel.payment-method.payment-detail')}}</p>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="container px-4 ">
                  <div class="px-2 pt-2 pb-3">
                    <div class="mx-auto d-block text-center text-truncate">
                      <div class="d-inline-block">
                        <div class="rounded-100 w-26px bg-green-opacity text-center d-inline-block mr-1" :class="{'bg-white':step == 1}">
                          <p class="mb-0 body-2 font-bold text-green position-relative" style="top: 3px;">1</p>
                        </div>
                        <p class="mb-0 body-2 font-semibold text-12 d-inline-block text-green-opacity mr-1 position-relative" style="top: 3px;" :class="{'text-white':step == 1}">{{$t("general.bill")}}</p>
                      </div>
                      <div class="d-inline-block">
                        <p class="mb-0 body-2 font-semibold text-12 d-inline-block text-green-opacity mx-1" style="top:2px;width: 15px;border-bottom: 1px solid #b5cc92" :class="{'text-white border-bottom-white':step == 1}"></p>
                        <div class="rounded-100 w-26px bg-green-opacity text-center d-inline-block mr-1" :class="{'bg-white':step == 2}">
                          <p class="mb-0 body-2 font-bold text-green position-relative" style="top: 3px;">2</p>
                        </div>
                        <p class="mb-0 body-2 font-semibold text-12 d-inline-block text-green-opacity mr-1 position-relative" style="top: 3px;"  :class="{'text-white':step == 2}">{{$t('hotel.payment')}}</p>
                        <p class="mb-0 body-2 font-semibold text-12 d-inline-block text-green-opacity mx-1" style="top:2px;width: 15px;border-bottom: 1px solid #b5cc92" :class="{'text-white border-bottom-white':step == 2}"></p>
                      </div>
                      <div class="d-inline-block">
                        <div class="rounded-100 w-26px bg-green-opacity text-center d-inline-block mr-1">
                          <p class="mb-0 body-2 font-bold text-green position-relative" style="top: 3px;">3</p>
                        </div>
                        <p class="mb-0 body-2 font-semibold text-12 d-inline-block text-green-opacity mr-1 position-relative" style="top: 3px;">{{$t('hotel.complete')}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';

	export default{
		props: {
			step: {
				type: Number,
				default: 1
			},
      backto:{
        type: String,
        default: ''
      }
		},
    computed:{
      link_back(){
        return this.backto == '' ? '/'+this.getMerchant().code+'/booking' : '/'+this.getMerchant().code+'/'+this.backto
      }
    },
		methods:{
			...mapGetters(['getMerchant'])
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/cartHeader.vue